// Template selectors
export const pdfFormTemplatesSelector = ({ pdfFormTemplates: { templates: value = [] } }: any) => value;
export const pdfFormTemplateSelector = ({ pdfFormTemplates: { template: value } }: any) => value;
export const pdfFormFieldsSelector = ({ pdfFormTemplates: { fields: value = [] } }: any) => value;
export const fetchingPdfFormTemplatesSelector = ({ pdfFormTemplates: { fetching: value } }: any) => value;
export const pdfFormTemplateCreatedSelector = ({ pdfFormTemplates: { templateCreated: value } }: any) => value;
export const pdfFormTemplateDeletedSelector = ({ pdfFormTemplates: { templateDeleted: value } }: any) => value;
export const pdfFormFieldsSavedSelector = ({ pdfFormTemplates: { fieldsSaved: value } }: any) => value;

// Submission selectors
export const pdfFormSubmissionsSelector = ({ pdfFormTemplates: { submissions: value = [] } }: any) => value;
export const pdfFormSubmissionSelector = ({ pdfFormTemplates: { submission: value } }: any) => value;
export const pdfFormSubmissionCreatedSelector = ({ pdfFormTemplates: { submissionCreated: value } }: any) => value;
export const pdfFormSubmissionEmailedSelector = ({ pdfFormTemplates: { submissionEmailed: value } }: any) => value;
export const pdfFormSubmissionDeletedSelector = ({ pdfFormTemplates: { submissionDeleted: value } }: any) => value;
